var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Component, Prop, Event, EventEmitter, html, svg, classMap, State } from '@sick-davinci/ce-decorators';
import { style } from './Checkbox.style';
/**
 * Checkboxes are selection controls that allow the user to select multiple options from a list of choices, including all or none.
 * It can be used within a toggle-group.
 * 
 * @example
 * ```html
 *  <davinci-checkbox checked>Deactivate me</davinci-checkbox>
 * ```
 * @slot {*} label for the checkbox
 */

export let Checkbox = (_dec = Component({
  tag: 'davinci-checkbox',
  style: [style]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = State(), _dec11 = Reflect.metadata("design:type", Boolean), _dec12 = Event(), _dec13 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec14 = Event(), _dec15 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec(_class = (_class2 = (_temp = class Checkbox extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "checked", _descriptor, this);

    _initializerDefineProperty(this, "disabled", _descriptor2, this);

    _initializerDefineProperty(this, "name", _descriptor3, this);

    _initializerDefineProperty(this, "value", _descriptor4, this);

    _initializerDefineProperty(this, "isempty", _descriptor5, this);

    _initializerDefineProperty(this, "change", _descriptor6, this);

    _initializerDefineProperty(this, "input", _descriptor7, this);

    this.clickTrap = () => {
      this.checked = !this.checked;
      this.change.emit(this.checked);
      this.input.emit(this.checked);
    };

    this.slotchanged = () => {
      // workaround since we can not target text nodes in ::slotted to set or reset padding and host(:empty) does not work on ShadyCSS
      if (this.textContent) {
        this.isempty = false;
      } else {
        this.isempty = true;
      }
    };
  }

  componentConnected() {
    this.addEventListener('click', this.clickTrap);
  }

  componentFirstRender() {
    this.slotchanged();
  }

  componentDisconnected() {
    this.removeEventListener('click', this.clickTrap);
  }

  render() {
    return html`
    <div class="cb_box">
      ${svg`
      <svg width="22px" height="22px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g stroke="none" stroke-width="1">
          <g>
            <polygon points="9 16.17 4.83 12 3.41 13.41 9 19 21 7 19.59 5.59"></polygon>
          </g>
        </g>
      </svg>`}
    </div><div class="${classMap({
      cb_label: true,
      empty: this.isempty
    })}">
      <slot @slotchange="${this.slotchanged}"></slot>
    </div>
    `;
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "checked", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "isempty", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
//# sourceMappingURL=Checkbox.js.map